import { useState, useEffect } from 'react';
import { supabase } from '../lib/supabase';
import type { FollowUpReminder } from '../types/followUp';

interface DashboardFollowUp extends FollowUpReminder {
  contact: {
    id: string;
    first_name: string;
    last_name: string;
    work_email: string;
    personal_email: string;
    company: {
      id: string;
      name: string;
    };
  };
}

export function useDashboardFollowUps(daysRange: number = 30, fetchDeep: boolean = false) {
  const [followUps, setFollowUps] = useState<DashboardFollowUp[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    async function fetchFollowUps() {
      try {
        const futureDate = new Date();
        futureDate.setDate(futureDate.getDate() + daysRange);

        const query = supabase
          .from('nrm_follow_up_reminders')
          .select(`
            *,
            contact:contact_id (
              id,
              first_name,
              last_name,
              work_email,
              personal_email,
              company:company_id (
                id,
                name
              )
            )
          `)
          .eq('completed', false)
          .lte('due_date', futureDate.toISOString())
          .order('due_date', { ascending: true });

        const { data, error: fetchError } = await query;

        if (fetchError) throw fetchError;
        setFollowUps(data || []);
      } catch (err) {
        console.error('Error fetching follow-ups:', err);
        setError('Failed to load follow-ups');
      } finally {
        setLoading(false);
      }
    }

    fetchFollowUps();
  }, [daysRange]);

  return { followUps, loading, error };
}